import * as Icons from "lucide-react";
import { FACILITIES } from "../../lib/constants";

export default function Facilities() {
  return (
    <section
      id="facilities"
      data-testid="facilities-section"
      className="relative py-24 md:py-32 bg-[#0B0B0B] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#FACC15] font-semibold mb-4">
              Facilities
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-semibold text-white max-w-2xl">
              Everything a serious student needs.
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed">
            Premium amenities across both branches. Designed for long, focused
            study hours with zero compromise.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {FACILITIES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div
                key={f.label}
                data-testid={`facility-${i}`}
                className="group relative bg-[#1A1A1A] hover:bg-[#211E1A] border border-white/5 hover:border-[#FACC15]/40 p-6 rounded-sm transition-all hover:-translate-y-1"
              >
                <div className="w-11 h-11 rounded-sm bg-[#2B2621] grid place-items-center mb-4 group-hover:bg-[#FACC15] transition-colors">
                  <Icon className="w-5 h-5 text-[#FACC15] group-hover:text-[#0F0F0F]" />
                </div>
                <div className="text-sm font-medium text-white leading-snug">
                  {f.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
